import { Link, NavLink, Outlet } from "react-router-dom";
import { ReactComponent as Logo } from "../../assets/James-Hope-University-Logo.svg";
import { ReactComponent as MenuIcon } from "../../assets/menu.svg";
// import { ReactComponent as Magnifier } from "../../assets/magnifier.svg";
import { ReactComponent as Envelope } from "../../assets/envelope.svg";
import { ReactComponent as Phone } from "../../assets/phone.svg";
import { ReactComponent as Whatsap } from "../../assets/whatsap.svg";
import { ReactComponent as Linkedin } from "../../assets/linkedin.svg";
import { ReactComponent as Facebook } from "../../assets/facebook.svg";
import { ReactComponent as Youtube } from "../../assets/youtube.svg";
import { ReactComponent as Twitter } from "../../assets/twitter.svg";
import { ReactComponent as Instagram } from "../../assets/instagram.svg";
import styles from "./styles.module.scss";
import { Fragment } from "react/jsx-runtime";
import { routes } from "../../routes";
import { Drawer } from "antd";
import { useState } from "react";

const ClientLayout = () => {
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen((prevState) => !prevState);
  };

  const onClose = () => {
    setOpen((prevState) => !prevState);
  };

  return (
    <main id="container" className={styles.container}>
      <header>
        <nav className={styles.header}>
          <Link to={"/"}>
            <Logo />
          </Link>

          <ul className={styles.links}>
            <li>
              <NavLink to={"/admission"}>
                {({ isActive }) => (
                  <>
                    <span>Admission</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>

            {/* <li>
              <NavLink to={"/student-life"}>
                {({ isActive }) => (
                  <>
                    <span>Student Life</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li> */}

            {/* <li>
              <NavLink to={"/about-us"}>
                {({ isActive }) => (
                  <>
                    <span>About Us</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li> */}

            <li>
              <NavLink to={"/contact-us"}>
                {({ isActive }) => (
                  <>
                    <span>Contact Us</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>

            <li>
              <NavLink to={routes.auth.login}>
                {({ isActive }) => (
                  <>
                    <span>Login</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>
          </ul>
          {/* <div className={styles.search}>
            <Magnifier />
            <input type="text" placeholder="Type here..." />
          </div> */}

          <MenuIcon className={styles.menu} onClick={showDrawer} />
        </nav>

        <Drawer onClose={onClose} open={open}>
          <ul className={styles.sideLink}>
            <li onClick={onClose}>
              <NavLink to={"/admission"}>
                {({ isActive }) => (
                  <>
                    <span>Admission</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>

            {/* <li onClick={onClose}>
              <NavLink to={"/student-life"}>
                {({ isActive }) => (
                  <>
                    <span>Student Life</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li> */}

            {/* <li onClick={onClose}>
              <NavLink to={"/about-us"}>
                {({ isActive }) => (
                  <>
                    <span>About Us</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li> */}

            <li onClick={onClose}>
              <NavLink to={"/contact-us"}>
                {({ isActive }) => (
                  <>
                    <span>Contact Us</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>

            <li onClick={onClose}>
              <NavLink to={routes.auth.login}>
                {({ isActive }) => (
                  <>
                    <span>Login</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>
          </ul>
        </Drawer>

        <nav className={styles.contact}>
          <section className={styles.smallGap}>
            <p>Any questions?</p>
            <div className="small-gap">
              <Envelope />
              <span>admission@pti.edu.ng</span>
            </div>

            <div className="small-gap">
              <Phone />
              <span>08023295684, 08028798994</span>
              <Whatsap className={styles.whatsappIcon} />
              <span>08082494883</span>
            </div>
          </section>

          <section className="small-gap">
            {/* <Link to={"/"}>Apply Now</Link> */}
            {/* <Link to={"/"}>Download our brochure</Link> */}
          </section>
        </nav>
      </header>

      <div>
        <Outlet />
      </div>

      <footer className={styles.footer}>
        <section className={styles.footerTop}>
          {/* Brand column */}
          <div className={styles.footerBrand}>
            <Logo className={styles.footerLogo} />
            <p className={styles.footerTagline}>
              Shaping Global Industry Giant Through Excellence in Education.
            </p>
          </div>

          {/* Quick Links column */}
          <div className={styles.footerColumn}>
            <h4 className={styles.footerHeading}>Quick Links</h4>
            <ul className={styles.footerList}>
              <li><Link to="/admission">Admission</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
              <li><Link to={routes.auth.login}>Student Portal</Link></li>
              <li>
                <a href="https://pti.edu.ng" target="_blank" rel="noopener noreferrer">
                  Visit Website
                </a>
              </li>
            </ul>
          </div>

          {/* Contact column */}
          <div className={styles.footerColumn}>
            <h4 className={styles.footerHeading}>Contact Us</h4>
            <ul className={styles.footerContactList}>
              <li>
                <span className={styles.contactLabel}>Address:</span>
                 PTI Campus, Effurun, Delta State
              </li>
              <li>
                <span className={styles.contactLabel}>Phone:</span>
                008062190657, 08023295684
              </li>
              <li>
                <span className={styles.contactLabel}>WhatsApp:</span>
                08028798994
              </li>
              <li>
                <span className={styles.contactLabel}>Email:</span>
                admission@pti.edu.ng ,
                <b></b>itsupport@pti.edu.ng
              </li>
            </ul>
          </div>
        </section>

        <hr className={styles.footerDivider} />

        <section className={styles.footerBottom}>
          <p className={styles.footerCopyright}>
            © {new Date().getFullYear()} Petroleum Training Institute, Effurum Delta State. All rights reserved.
          </p>
          <div className={styles.socialIcons}>
            {social.map((item, index) => (
              <Fragment key={index}>{item}</Fragment>
            ))}
          </div>
        </section>
      </footer>
    </main>
  );
};

export default ClientLayout;

const footerLinks = [
  // {
  //   title: "Explore",
  //   links: [
  //     { title: "Home", path: "/" },
  //     { title: "About", path: "/about-us#about-us" },
  //     // { title: "Academics", path: "/academics" },
  //     { title: "Admission", path: "/admission" },
  //     { title: "Student Life", path: "/student-life#student-life" },
  //   ],
  // },
  // {
  //   title: "Information For",
  //   links: [
  //     // { title: "How To Apply", path: "/how-to-apply" },
  //     { title: "Campus Experience", path: "/student-life#campus-experience" },
  //     { title: "Student Activities", path: "/student-life#student-activities" },
  //     { title: "Support & Guidance", path: "/student-life#support-guidance" },
  //     { title: "Fitness & Athletics", path: "/student-life#fitness-athletics" },
  //   ],
  // },
  // {
  //   title: "Student And Staff",
  //   links: [
  //     // { title: "Apply Now", path: "/admission#admission" },
  //     // { title: "Student Portal", path: "/student-portal" },
  //     // { title: "Teachers", path: "/teachers" },
  //     // { title: "Alumni Club", path: "/alumni-club" },
  //     // { title: "Blog", path: "/student-life#student-life" },
  //   ],
  // },
];

const social = [
  <Linkedin />,
  <Facebook />,
  <Youtube />,
  <Twitter />,
  <Instagram />,
];
